export const splash = false
export const siteName = "Mileage.autos"
export const siteDescription = "A site to help you get the most of every automobile per mile."
export const siteImage = undefined
export const siteUrl = "https://mileage.autos"
export const titleSeparator = "|"
export const trailingSlash = false
export const language = "en"
export const indexable = true